"use no memo";
import { useEffect } from "react";
import { env } from "@/lib";
import { Intercom } from "@intercom/messenger-js-sdk";

export default function IntercomProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    try {
      Intercom({
        region: "eu",
        app_id: env("VITE_INTERCOM_ID"),
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  return <>{children}</>;
}
